import { AcademyMockApi } from '@sbd-doug-frontend/app/mock-api/apps/academy/api';
import { ActivitiesMockApi } from '@sbd-doug-frontend/app/mock-api/pages/activities/api';
import { AnalyticsMockApi } from '@sbd-doug-frontend/app/mock-api/dashboards/analytics/api';
import { AuthMockApi } from '@sbd-doug-frontend/app/mock-api/common/auth/api';
import { ChatMockApi } from '@sbd-doug-frontend/app/mock-api/apps/chat/api';
import { ContactsMockApi } from '@sbd-doug-frontend/app/mock-api/apps/contacts/api';
import { CryptoMockApi } from '@sbd-doug-frontend/app/mock-api/dashboards/crypto/api';
import { ECommerceInventoryMockApi } from '@sbd-doug-frontend/app/mock-api/apps/ecommerce/inventory/api';
import { FileManagerMockApi } from '@sbd-doug-frontend/app/mock-api/apps/file-manager/api';
import { FinanceMockApi } from '@sbd-doug-frontend/app/mock-api/dashboards/finance/api';
import { HelpCenterMockApi } from '@sbd-doug-frontend/app/mock-api/apps/help-center/api';
import { IconsMockApi } from '@sbd-doug-frontend/app/mock-api/ui/icons/api';
import { MailboxMockApi } from '@sbd-doug-frontend/app/mock-api/apps/mailbox/api';
import { MessagesMockApi } from '@sbd-doug-frontend/app/mock-api/common/messages/api';
import { NavigationMockApi } from '@sbd-doug-frontend/app/mock-api/common/navigation/api';
import { NotesMockApi } from '@sbd-doug-frontend/app/mock-api/apps/notes/api';
import { NotificationsMockApi } from '@sbd-doug-frontend/app/mock-api/common/notifications/api';
import { ProjectMockApi } from '@sbd-doug-frontend/app/mock-api/dashboards/project/api';
import { SearchMockApi } from '@sbd-doug-frontend/app/mock-api/common/search/api';
import { ScrumboardMockApi } from '@sbd-doug-frontend/app/mock-api/apps/scrumboard/api';
import { ShortcutsMockApi } from '@sbd-doug-frontend/app/mock-api/common/shortcuts/api';
import { TasksMockApi } from '@sbd-doug-frontend/app/mock-api/apps/tasks/api';
import { UserMockApi } from '@sbd-doug-frontend/app/mock-api/common/user/api';

export const mockApiServices = [
    AcademyMockApi,
    ActivitiesMockApi,
    AnalyticsMockApi,
    AuthMockApi,
    ChatMockApi,
    ContactsMockApi,
    CryptoMockApi,
    ECommerceInventoryMockApi,
    FileManagerMockApi,
    FinanceMockApi,
    HelpCenterMockApi,
    IconsMockApi,
    MailboxMockApi,
    MessagesMockApi,
    NavigationMockApi,
    NotesMockApi,
    NotificationsMockApi,
    ProjectMockApi,
    SearchMockApi,
    ScrumboardMockApi,
    ShortcutsMockApi,
    TasksMockApi,
    UserMockApi
];
